import axios from "axios";
import { getUserDetails } from "../../config/apiConfig";
import {
    FETCH_PROFILEUSER_BEGIN,
    FETCH_PROFILEUSER_SUCCESS,
    FETCH_PROFILEUSER_FAILURE
} from '../constants/profile';
import { sbaAxios } from "../utils/sbaAxios";

export const GetUserDetails = (token) => {
    return (dispatch) => {
        dispatch(fetchProfileUserBegin());
        sbaAxios({url:`${getUserDetails}`,method:'get'}).then((repos) => {
            const userDetails = repos;
            dispatch(fetchProfileUserSuccess(userDetails));
            return userDetails;
        })
        .catch((error) =>{ 
        dispatch(fetchProfileUserFailure(error));});
    };
}

export const fetchProfileUserBegin = () => ({
    type: FETCH_PROFILEUSER_BEGIN,
});

export const fetchProfileUserSuccess = (userDetails) => ({
    type: FETCH_PROFILEUSER_SUCCESS,
    payload: { userDetails },
});


export const fetchProfileUserFailure = (errorMessage) => ({
    type: FETCH_PROFILEUSER_FAILURE,
    payload: { errorMessage }
});
